/** Typed wrapper over fetch for /api/broker/kite/*. */

import { getJson } from "@/lib/http";
import type { KiteLoginUrl, KiteLtp, KitePositions, KiteResolve, KiteStatus } from "@/types/broker";

const BASE = "/api/broker/kite";

export const brokerApi = {
  loginUrl(): Promise<KiteLoginUrl> {
    return getJson<KiteLoginUrl>(`${BASE}/login`);
  },
  status(): Promise<KiteStatus> {
    return getJson<KiteStatus>(`${BASE}/status`);
  },
  logout(): Promise<KiteStatus> {
    return getJson<KiteStatus>(`${BASE}/logout`, { method: "POST" });
  },
  ltp(symbol: string): Promise<KiteLtp> {
    return getJson<KiteLtp>(`${BASE}/ltp?symbol=${encodeURIComponent(symbol)}`);
  },
  resolve(underlying: "NIFTY" | "SENSEX", strike: number, side: "CE" | "PE"): Promise<KiteResolve> {
    const params = new URLSearchParams({
      underlying,
      strike: String(strike),
      side,
    });
    return getJson<KiteResolve>(`${BASE}/resolve?${params.toString()}`);
  },
  positions(): Promise<KitePositions> {
    return getJson<KitePositions>(`${BASE}/positions`);
  },
};
